<template>
  <v-main>
    <router-view />

    <dashboard-core-footer />
    <dashboard-core-snackBar />
    <dashboard-core-overlay />
  </v-main>
</template>

<script>
export default {
  name: "DashboardCoreView",
  components: {
    DashboardCoreFooter: () => import("./Footer"),
    DashboardCoreSnackBar: () => import("./SnackBar"),
    DashboardCoreOverlay: () => import("./Overlay"),
  },
};
</script>
